import { useMap } from "react-leaflet";
import { useEffect } from "react";
import type L from "leaflet";

const defaultPadding: [number, number] = [50, 50];

export function FitBounds({
  bounds,
  maxZoom = 12,
  padding = defaultPadding,
}: {
  bounds: L.LatLngBoundsExpression | null;
  maxZoom?: number;
  padding?: [number, number];
}) {
  const map = useMap();

  useEffect(() => {
    if (bounds) {
      map.fitBounds(bounds, { padding, maxZoom });
    }
  }, [map, bounds, maxZoom, padding]);

  return null;
}
